import React, { useState } from "react";
import Modal from "../../../components/modal";
import { toast } from "react-hot-toast";
import { IoClose } from "react-icons/io5";

export function NewChapterModal({ onDone }) {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState("");

  const handleSubmit = async () => {
    try {
      if (!value.trim()) return toast.error("Chapter cannot be empty");

      setIsOpen(false);
      setValue("");
      onDone(value);
    } catch (error) {
      toast.error("Failed to create new chapter");
    }
  };

  if (!isOpen)
    return (
      <button onClick={() => setIsOpen(true)} className="w-full flex items-center gap-2 px-2.5 py-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-50">
        <div className="w-4 h-4" /> 
        <div className="w-5 h-5 rounded overflow-hidden flex-shrink-0 bg-gray-100 border border-gray-200 flex items-center justify-center">
          <IoClose className="w-3.5 h-3.5 rotate-45" />
        </div>
        <span className="text-sm">Add Workshop</span>
      </button>
    );

  return (
    <>
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} className="max-w-xl w-full">
        <div className="p-6">
          <div className="flex flex-col mb-6">
            <h2 className="text-xl font-semibold mb-4">Create New Chapter</h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Chapter Name</label>
                <input
                  type="text"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  placeholder="Enter new chapter name"
                  className="w-full text-sm text-gray-600 border border-gray-300 rounded-md p-2 focus:border-blue-500 focus:outline-none"
                />
              </div>
            </div>
          </div>
          <div className="flex justify-end gap-3">
            <button onClick={() => setIsOpen(false)} className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-500">
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              disabled={!value?.trim()}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed">
              Continue
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
} 